export interface CreateCorporateRoleDto {
  name: string; // Required, max 100
  description?: string | null; // Max 500
  isActive?: boolean; // Default: true
  isDefault?: boolean; // Default: false
}
